<template>
  <div class="dstep">
    <div class="dstep__head">
      <h2 class="dstep__title">{{ $t("property.create.description.instructions") }}</h2>
    </div>

    <div class="dstep__card">
      <v-form lazy-validation v-model="valid" ref="description">
        <div class="dstep__label">Descripción</div>

        <div class="dstep__editor">
          <wysiwyg v-model="property.description" />
        </div>
        </v-form>
    </div>

    <div class="dstep__footer">
      <v-btn text color="primary" class="rounded-lg" @click="$router.go(-1)">
        {{ $t("action.close_and_continue_later") }}
      </v-btn>
      <v-btn color="accent" depressed class="rounded-lg" @click="nextStep">
        {{ $t("action.next") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { EditProperty } from "@/graphql/mutations/properties";

export default {
  data() {
    return {
      valid: true,
      property: {
        description: null
      }
    };
  },

  props: {
    fetchedProperty: {
      type: Object,
      required: true
    }
  },

  created() {
    this.property.description = this.fetchedProperty.description;
  },

  watch: {
    valid(newVal) {
      if (!newVal) {
        this.$vuetify.goTo(0);
      }
    }
  },

  methods: {
    nextStep() {
      this.editProperty();
    },

    editProperty() {
      if (this.valid) this.$refs.description.validate();

      if (this.valid) {
        this.$apollo
          .mutate({
            mutation: EditProperty,
            variables: {
              input: {
                attributes: this.property,
                propertyId: this.fetchedProperty.id
              }
            }
          })
          .then(res => {
            this.$emit("continue", res.data.editProperty.property);
          });
      }
    }
  }
};
</script>

<style scoped>
.dstep__head { margin-bottom: 16px; }
.dstep__title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1814;
  margin: 0;
  line-height: 1.2;
}

.dstep__card {
  background: #fff;
  border: 1px solid #ece7de;
  border-radius: 14px;
  padding: 22px;
}
.dstep__label {
  font-size: 10px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #a39a8c;
  font-weight: 600;
  margin-bottom: 10px;
}

/* warm the wysiwyg editor chrome */
.dstep__editor >>> .editr {
  border: 1px solid #e3ddd2;
  border-radius: 10px;
  overflow: hidden;
}
.dstep__editor >>> .editr--toolbar {
  background: #faf8f4;
  border-bottom: 1px solid #ece7de;
}
.dstep__editor >>> .editr--content {
  min-height: 240px;
  font-size: 14px;
  color: #1a1814;
  line-height: 1.6;
}

.dstep__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
}
</style>
